<template>
  <IQOS :title="$t('settings_cafe.cafe_info.info')" :enabled="editing" required>
    <BaseInput 
      class="mt-16" 
      fullWidth 
      v-model="edit_fields.name" 
      :disabled="!editing"/>

    <BaseTextarea 
      class="mt-16 w-100" 
      rows="6"
      v-model="edit_fields.description"
      :disabled="!editing"/>

    <BaseSelect
      class="mt-16 w-100"
      v-model="edit_fields.price_level"
      :disabled="!editing"
    >
      <option :value="null" disabled>
        {{ $t("settings_cafe.cafe_info.option") }}
      </option>
      <option value="$">$</option>
      <option value="$$">$$</option>
      <option value="$$$">$$$</option>
      <option value="$$$$">$$$$</option>
    </BaseSelect>

    <template #actions>
      <IQOSActions 
        v-model="editing"
        @accept="saveChanges"/>
    </template>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      editing: false,
      invalid_form: false,
      edit_fields: {
        name: null,
        description: null,
        price_level: null
      },
    };
  },
  components: {},
  methods: {
    resetValue() {
      this.edit_fields.name = this.cafe.name;
      this.edit_fields.price_level = this.cafe.price_level || '$';
      this.edit_fields.description = this.cafe.description || null;      
    },
    saveChanges() {
      this.$store.commit("patchCafeGeneralData", this.edit_fields);

      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "cafe_settings",
        payload: this.edit_fields,
      });

      this.editing = false;
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    owner() {
      return this.$store.state.owner;
    },
  },
  mounted() {
    this.resetValue();
  },
};
</script>

<style scoped>
</style>
